import React from "react";
import { StoreListingTableProps } from "../../type";
import TableExtend from "shared/components/Table";

const StoreListingTable = ({
  stores,
  tableMapping,
  onFiltered,
  onRowClick,
}: StoreListingTableProps) => {
  return (
    <TableExtend
      responsive
      striped
      tableData={stores}
      tableMapping={tableMapping}
      onFilter={onFiltered}
      onRowClick={onRowClick}
    />
  );
};

export default StoreListingTable;
